import { Link } from "react-router-dom";
import type { Product } from "@/mocks/products";

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-product-shop
      className="group flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full h-[240px] overflow-hidden bg-background-100">
        <img
          src={product.cover}
          alt={`${product.name} 产品图`}
          title={`${product.name} - 糖心VLGO`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-700 backdrop-blur-sm">
          {product.series}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-5">
        <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
          {product.name}
        </h3>
        <p className="mt-1 text-xs text-accent-600 font-medium">{product.tagline}</p>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
          {product.summary}
        </p>
        <div className="mt-4 flex items-center justify-between">
          <span className="font-heading text-xl font-extrabold text-primary-600">{product.price}</span>
          <span className="flex items-center gap-1 text-sm text-foreground-500 group-hover:text-primary-600 transition-colors">
            查看详情
            <i className="ri-arrow-right-line leading-none"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}